import { TranslatePipe } from '@ngx-translate/core';

import { CurrencyHeadlinePipe } from '@shared/pipes/currency-headline.pipe';
import { ImpressionPipe } from '@shared/pipes/impression/impression.pipe';
import { SpendPipe } from '@shared/pipes/spend/spend.pipe';

import { AdcCurrencyPipe } from './currency.pipe';
import { AdcPercentPipe } from './percent.pipe';
import { ShortPipe } from './short.pipe';

export const pipeProviders = [
    ShortPipe,
    AdcCurrencyPipe,
    AdcPercentPipe,
    TranslatePipe,
    CurrencyHeadlinePipe,
    SpendPipe,
    ImpressionPipe,
];
